var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistributionGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8fdf00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-857 -786.778)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.587,
    cy: 4.587,
    r: 4.587,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 859.482, 791.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M865,786.778a8,8,0,1,0,8,8A8,8,0,0,0,865,786.778Zm0,14.273a6.274,6.274,0,1,1,6.273-6.273A6.281,6.281,0,0,1,865,801.052Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributionGroup);
export default __webpack_public_path__ + "static/media/distribution-group.9708824bd9824a613c96cb4a52a796ab.svg";
export { ForwardRef as ReactComponent };